import { BaseDashboardInfoComponent } from './base-dashboard-info.component';
import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { IObject } from '../../../../../type_definitions/datatypes';
import * as _ from 'underscore';

@Component({
  selector: 'number-of-fans-info',
  template: `
    <span *ngIf="section?.report?.data">{{totalFans}}</span>
  `
})
export class NumberOfFansInfoComponent extends BaseDashboardInfoComponent implements OnChanges {
  public totalFans:string;

  public ngOnChanges(changesObj:SimpleChanges):void {
    if (changesObj.loading) {
      this.getCountsFromReportData();
    }
  }

  private getCountsFromReportData():void {
    const rowData:IObject = this.section.report.data?.data;
    const totalFans:number = _.filter(rowData, (data:IObject) => data['Detrast_ds'] === 'Fan').length;
    this.totalFans = `${totalFans} ${totalFans < 2 ? 'Fan' : 'Fans'}`;
  }
}